import { useParams } from "react-router-dom";
import { useHomeQuery } from "../../../queries/useHomeQuery";

import NavCategoryPage from "./NavbarCategory";
import CategoryOne from "./CategoryOne";
import CategoryTwo from "./CategoryTwo";
import CategoryThree from "./CategoryThird";


const CategoryRouter = () => {
  const { slug } = useParams();

  const { data, isLoading, isError } = useHomeQuery();
  const categories = data?.categories || [];

  if (isLoading) return <h2>Loading...</h2>;
  if (isError) return <h2>Error loading categories</h2>;
  if (categories.length === 0) return <h2>No categories found</h2>;

  const firstCategorySlug = categories[0]?.slug;
  const secondCategorySlug = categories[1]?.slug;
  const thirdCategorySlug = categories[2]?.slug;

  // ✅ FIRST
  if (slug === firstCategorySlug) {
    return <CategoryOne selectedCategory={slug} />;
  }

  // ✅ SECOND
  if (slug === secondCategorySlug) {
    return <CategoryTwo selectedCategory={slug} />;
  }

  // ✅ THIRD
  if (slug === thirdCategorySlug) {
    return <CategoryThree selectedCategory={slug} />;
  }

  // ✅ DEFAULT
  return <NavCategoryPage />;
};

export default CategoryRouter;